import { styled } from '@ublend-npm/aulaui-core';

export const AulaEditorWrapper = styled('div')(({ isSubmitting }) => ({
  opacity: isSubmitting ? 0.5 : 1,
}));
